
const LOADING_CIRCUITOS = (state, payload) => {
  state.carregando = payload
}

const INSERE_CIRCUITOS = (state, payload) => {
  state.items = payload
}

const INSERE_CIRCUITO_SELECIONADO = (state, payload) => {
  state.selecionado = payload
}

const INSERIR_VISAO_MACROFASE = (state, payload) => {
  state.visaoMacrofase = payload
}

const INSERIR_INDICADORES_BACKLOG = (state, payload) => {
  state.indicadorBacklog = payload
}

export {
  LOADING_CIRCUITOS,
  INSERE_CIRCUITOS,
  INSERE_CIRCUITO_SELECIONADO,
  INSERIR_VISAO_MACROFASE,
  INSERIR_INDICADORES_BACKLOG,
}